<template>
  <div class="flex flex-col">
    <InputHeader :label="label" :description="description" :question-type="type" />
    <input
      v-model="computedValue"
      type="number"
      :name="name"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      class="border border-gray-500 rounded text-black"
      :class="small ? 'p-1' : 'p-2'"
      :disabled="disabled"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import InputHeader from './InputHeader.vue'

type Props = {
  modelValue: number | undefined
  min?: number
  max?: number
  label?: string
  description?: string
  placeholder?: string
  name?: string
  small?: boolean
  disabled?: boolean
  type?: string
}
const props = defineProps<Props>()
const emit = defineEmits<{
  'update:modelValue': [value: number | undefined]
}>()

const computedValue = computed({
  get: () => props.modelValue,
  set: (value: number | undefined) => emit('update:modelValue', value ?? undefined),
})
</script>

<style lang="scss"></style>
